import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { AppcuesSDK } from "./service";

@Injectable()
export class AppcuesOnboardingRouteObserver {
    public locationUrl: string;

    constructor(private router: Router) {}

    public listen() {
        this.router.events.subscribe(event => {
            const userIsChangingOfPage =
                event instanceof NavigationEnd &&
                this.locationUrl !== window.location.href;

            if (userIsChangingOfPage) {
                AppcuesSDK && AppcuesSDK.page();
                this.locationUrl = window.location.href;
            }
        });

        return this;
    }
}
